import { render, staticRenderFns } from "./CustomerPurchaseOrderPreview.vue?vue&type=template&id=1c853b87&"
import script from "./CustomerPurchaseOrderPreview.vue?vue&type=script&lang=js&"
export * from "./CustomerPurchaseOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPurchaseOrderPreview.vue?vue&type=style&index=0&id=1c853b87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports